import { Component, OnDestroy, OnInit, ViewChildren, QueryList, AnimationTransitionEvent } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Answer, Question } from '../../models/qa.model';
import { HistoryService } from '../../services/history.service';
import { MetaService } from '../../services/meta.service';
import { QaService } from '../../services/qa.service';
import { StartupService } from '../../services/startup.service';
import { trigger, style, animate, transition, group, query, stagger } from '@angular/animations';
import { WoodConditionImageService } from '../../services/wood-condition.service';
import { WoodConditionImage } from '../../models/wood-condition-image.model';
import { QuestionTypeEnum } from '../../models/question-type';
import { WoodGrainImage } from '../../models/wood-grain-image.model';
import { WoodGrainImageService } from '../../services/wood-grain.service';
import { WoodLookImage } from '../../models/wood-look-image.model';
import { WoodLookImageService } from '../../services/wood-look.service';
import { AnswerInfoService } from '../../services/answer-info.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
  animations: [
    trigger('stepAnimate', [
      transition('void => in', [
        query('.animate-step', style({ transform: 'translateX(600px)', opacity: 0 }), { optional: true }),
        query('.animate-step',
          stagger('50ms', group([
            animate('200ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 1 })),
            animate('300ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(0)' }))
          ])), { optional: true })
      ]),
      transition('in => out', [
        query('.animate-step',
          stagger('50ms', group([
            animate('200ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 0 })),
            animate('300ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(-600px)' }))
          ])), { optional: true })
      ])
    ])
  ]
})
export class StepComponent implements OnInit, OnDestroy {
  letSelectAnswer: boolean = false;
  animationSubscription: Subscription;
  animationState: string = 'out';
  subscription: Subscription;
  selectedAnswer: Answer;
  currentStep: Question;
  questionStepNodeId: number = 0;
  answers: Answer[] = [];
  @ViewChildren('answerContent') answerContent: QueryList<any>;
  stepsCompleted: number;
  woodConditionImages: WoodConditionImage[];
  woodGrainImages: WoodGrainImage[];
  woodLookImages: WoodLookImage[];
  arraycolors: string[] = ["CAPE COD GRAY","WHITE BIRCH","OUTSIDE WHITE"];

  constructor(
    private qaService: QaService,
    public startupService: StartupService,
    private router: Router,
    private route: ActivatedRoute,
    public metaTagService: MetaService,
    private historyService: HistoryService,
    public woodConditionImageService: WoodConditionImageService,
    public woodGrainImageService: WoodGrainImageService,
    public woodLookImageService: WoodLookImageService,
    private answerInfoService: AnswerInfoService
  ) { }

  ngOnInit() {
    this.animationSubscription = this.qaService.animationState.subscribe(x => {
      this.animationState = x;
    });

    this.qaService.setAnimationState('out');
    this.route.params.subscribe(params => {
      this.questionStepNodeId = parseInt(params['nodeId'] === null ? 0 : params['nodeId'], 10);
      this.currentStep = this.startupService.startupData.Questions.find(x => x.NodeId === this.questionStepNodeId);
      this.woodConditionImages = this.startupService.startupData.WoodConditionImages;
      this.woodGrainImages = this.startupService.startupData.WoodGrainImages;
      this.woodLookImages = this.startupService.startupData.WoodLookImages;

      if (this.currentStep !== undefined) {
        const woodType = this.answerInfoService.getSelectedWoodType();

        this.currentStep.AnswerIds.forEach((answerId) => {

          const answer = this.startupService.startupData.Answers.find(x => x.NodeId === answerId);

          if (answer.QuestionType === this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.WoodCondition) && answer.OverrideImage) {
            const woodImage = this.woodConditionImages.find(c => c.WoodType === woodType && c.WoodCondition === answer.WoodConditionFilter);
            if (woodImage !== undefined) {
              answer.Image = woodImage.WoodImage;
            }
          }

          if (answer.QuestionType === this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.WoodCondition) && answer.OverrideImage) {
            if (answer.QuestionType === this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.WoodCondition)) {
              const woodImage = this.woodConditionImages.find(c =>
                c.WoodType === woodType && c.WoodCondition === answer.WoodConditionFilter
              );
              if (woodImage !== undefined) {
                answer.Image = woodImage.WoodImage;
              }
            }
          }

          if (answer.QuestionType === this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.WoodGrain) && answer.OverrideImage) {
            const woodCondition = this.answerInfoService.getSelectedWoodCondition();
            const woodGrainImage = this.woodGrainImages.find(c =>
              c.WoodType === woodType && c.WoodCondition === woodCondition && c.WoodGrain === answer.WoodGrainFilter
            );
            if (woodGrainImage !== undefined) {
              answer.Image = woodGrainImage.WoodImage;
            }
          }

          if (answer.QuestionType === this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.StainGoal) && answer.OverrideImage) {
            const woodCondition = this.answerInfoService.getSelectedWoodCondition();
            const woodGrain = this.answerInfoService.getSelectedWoodGrain();
            const woodLookImage = this.woodLookImages.find(c =>
              c.WoodType === woodType && c.WoodCondition === woodCondition &&
              c.WoodGrain === woodGrain && c.WoodLook === answer.WoodLookFilter
            );
            if (woodLookImage !== undefined) {
              answer.Image = woodLookImage.WoodImage;
            }
          }

          if (answer.QuestionType === this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.ProductQuality)) {
            const project = this.answerInfoService.getSelectedProject();
            const opacity = this.qaService.answers.selectedColor.Opacity;
            const productQuality = answer.ProductQualityFilter;

            if (answer.Subtitle === '') {
              const answerDescription = this.startupService.startupData.ProductValueDescriptions.find(x =>
                x.ProjectFilter === project && x.OpacityFilter === opacity && x.ProductQualityFilter === productQuality &&
                x.Culture === window.location.href.split('/')[3]
              );
              answer.Subtitle = answerDescription ? answerDescription.Description : '';
            }
          }

          if (this.qaService.answers.selectedColor !== undefined){
            
            const NotColors = (this.arraycolors.indexOf(this.qaService.answers.selectedColor.Name.toUpperCase()) > -1); 
           
            if (answer.ProductNodeAlias == "Paramount-Semi-Transparent-Semi-Solid" && NotColors)
            {                
              console.log('NotColors')            
            }
            else if (answer.ProductNodeAlias == "Paramount-Semi-Transparent-Semi-Solid" ){
              console.log('this.qaService.answers.selectedColor',this.qaService.answers.selectedColor)
              if (this.qaService.answers.selectedColor.BaseProduct !== 0){
                console.log("Paramount-Semi-Transparent-Semi-Solid")
                answer.Image = this.qaService.answers.selectedColor.TransparencyImage;
              }
              this.answers.push(answer);
            }
            else if (answer.ProductNodeAlias == "Paramount-Solid"){
              if (this.qaService.answers.selectedColor.BaseProduct !== 0){
                console.log("Paramount-Solid")
                answer.Image = this.qaService.answers.selectedColor.TransparencyImage;
              }
              
              this.answers.push(answer);
            }
            else{
              // console.log('push(answer)',answer)
              this.answers.push(answer);
            }
          }
          else{
            this.answers.push(answer);
          }
          // this.answers.push(answer);
        });

        this.qaService.updateProgress(this.currentStep.Progress);
        this.metaTagService.setMetaTags(
          // this.currentStep.DocumentPageTitle,
          '',
          this.currentStep.DocumentPageDescription,
          this.currentStep.DocumentPageKeyWords
        );

        this.historyService.addStep();
        this.stepsCompleted = this.historyService.getCompletedSteps();
        setTimeout(() => {
          this.answerContent.forEach(el => {
            el.nativeElement.style.marginTop = -(el.nativeElement.offsetHeight / 2) + 'px';
          });
        }, 250);
        this.qaService.setAnimationState('in');
      }
    });
  }

  setSelectedAnswer(answer: Answer) {
    if (this.letSelectAnswer) {
      this.qaService.CurrentAnswer = answer;
      this.qaService.setAnimationState('out');
      this.qaService.answers.selectedAnswers.push(this.qaService.CurrentAnswer);
    }

    // When someone uses the Browser back button and changes their answers, clear the array and add the new answer
    const lastAnswer = this.qaService.answers.selectedAnswers[this.qaService.answers.selectedAnswers.length - 1];
    if (this.qaService.answers.selectedAnswers.filter(x => x.QuestionType === lastAnswer.QuestionType).length > 1) {
      const firstIndex = this.qaService.answers.selectedAnswers.findIndex(x => x.QuestionType === lastAnswer.QuestionType);
      this.qaService.answers.selectedAnswers.splice(firstIndex, this.qaService.answers.selectedAnswers.length - firstIndex);
      this.qaService.answers.selectedAnswers.push(lastAnswer);
    }
  }
  animationEnd(event: AnimationTransitionEvent) {
    if (this.qaService.CurrentAnswer) {
      if (event.fromState === 'in' && this.qaService.CurrentAnswer.AnswerConfirmationNodeId !== 0) {
        const link = this.startupService.getStepConfirmationRouterLink2(
          this.qaService.CurrentAnswer.NodeId, this.qaService.CurrentAnswer.AnswerConfirmationNodeId
        );
        this.router.navigate(link);
        return;
      }
      if (event.fromState === 'in' && this.qaService.CurrentAnswer.ProductNodeAlias !== null) {
        this.router.navigate(this.startupService.getProductRouterLink(this.qaService.CurrentAnswer.ProductNodeAlias));
        return;
      }
      if (this.qaService.CurrentAnswer.QuestionType !== this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.ProductQuality)) {
        this.router.navigate(this.startupService.getStepWithNodeRouterLink(this.qaService.CurrentAnswer.NodeId));
      }
    }
    if (event.fromState === 'void') {
      this.letSelectAnswer = true;
    }
  }

  ngOnDestroy() {
    this.animationSubscription.unsubscribe();
    this.qaService.setAnimationState('out');
  }
}


// WEBPACK FOOTER //
// ./src/app/components/step/step.component.ts